<template>
  <div class="collection">
    <div class="title">
      <i></i>
      <b></b>
      我的收藏
    </div>
    <div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="0"></el-tab-pane>
        <el-tab-pane label="CAD户型图" name="1"></el-tab-pane>
        <el-tab-pane label="设计案例" name="2"></el-tab-pane>
        <el-tab-pane label="CAD图库" name="3"></el-tab-pane>
        <el-tab-pane label="高清贴图" name="4"></el-tab-pane>
        <!-- <el-tab-pane label="设计师" name="5"></el-tab-pane> -->
      </el-tabs>
    </div>
    <div class="s-p">
      <el-date-picker
        v-model="value2"
        type="daterange"
        class="dateTime"
        align="left"
        unlink-panels
        range-separator="至"
        start-placeholder="发布开始日期"
        end-placeholder="发布结束日期"
        value-format="YYYY-MM-DD"
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <div class="ml-1">
        <el-button @click="getData" class="btn2" type="primary">查询</el-button>
        <el-button class="btn3" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="t-p">
      <el-table
        class="v-t-table"
        stripe
        v-loading="loading"
        :data="tableData.list"
        style="width: 100%;overflow-y:scroll"
      >
        <el-table-column type="index" label="序号" align="center" width="180" />
        <el-table-column prop="name" label="作品名称" align="center" />
        <el-table-column prop="userName" label="作者名称" align="center" />
        <el-table-column prop="type" label="作品类型" align="center">
          <template slot-scope="scope">
            <span>{{ flagType[scope.row.type] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格（元）" align="center" />
        <el-table-column prop="createTime" label="发布日期" align="center">
          <template slot-scope="scope">
            <span>{{
              $dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="270">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              plain
              @click="handleEdit(scope.row)"
              >查看收藏</el-button
            >
            <el-button
              type="danger"
              plain
              @click="handleDelete(scope.row)"
              size="mini"
              >取消收藏</el-button
            >
            <!-- <el-button type="danger" size="mini" plain @click="qxpz(scope.row)"
              >权限配置</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="p-p">
      <el-pagination
        class="page"
        background
        layout="prev, pager, next"
        @current-change="changePage"
        :current-page="searchParams.pageNo"
        :total="tableData.total"
        :page-size="searchParams.pageSize"
      />
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      loading: false,
      changeName: "",
      activeName: "0",
      value2: [],
      searchParams: {
        createTimeStart: "",
        createTimeEnd: "",
        pageNo: 1,
        pageSize: 10,
        type: 0
      },
      flagType: {
        1: "CAD户型图",
        2: "设计案例",
        3: "CAD图库",
        4: "高清贴图"
      },
      tableData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    handleTabClick() {
      this.searchParams.type = this.activeName;
      this.getData();
    },
    handleEdit(row) {
      // let routeUrl = this.$router.resolve({
      //   path: "/page_details",
      //   query: { id: row.id },
      // });
      let routeUrl = this.$router.resolve({
        path: `/detail/${row.id}.html`
      });
      window.open(routeUrl.href, "_blank");
    },
    handleDelete(row) {
      this.$confirm("确认要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$get("collect/cancelCollect", { mcId: row.id }).then(res => {
          this.getData();
          this.$message.success("取消收藏");
        });
      });
    },

    changePage(page) {
      this.searchParams.pageNo = page;
      this.getData();
    },

    reset() {
      this.value2 = [];
      this.searchParams.createTimeStart = "";
      this.searchParams.createTimeEnd = "";
    },
    getData() {
      if (this.value2.length > 0) {
        this.searchParams.createTimeStart = this.value2[0];
        this.searchParams.createTimeEnd = this.value2[1];
      }
      const p = {
        userId: sessionStorage.getItem("userId"),
        ...this.searchParams
      };
      this.loading = true;
      this.$post("collect/queryCollectMaterialCenterList", p).then(res => {
        this.tableData = res.data;
        this.loading = false;
      });
    }
  }
};
</script>
<style lang="less">
.el-table__body-wrapper::-webkit-scrollbar {
  /*width: 0;宽度为0隐藏*/
  width: 0px;
}
</style>
<style lang="less" scoped>
.btn3 {
  margin-left: 8px;
}
.v-t-table {
  height: 650px;
}
.collection {
  width: 100%;
  .title {
    display: flex;
    font-size: 22px;
    padding: 0 10px;
    align-items: center;
    line-height: 40px;
    color: #5c80d9;
    border-bottom: 1px solid rgba(229, 229, 229, 1);
    i {
      display: block;
      height: 20px;
      margin-right: 1px;
      border-left: 1px solid #5c80d9;
    }
    b {
      display: block;
      height: 20px;
      margin-right: 8px;
      border-left: 2.5px solid #5c80d9;
    }
    .el-button {
      margin-left: auto;
      margin-right: 8px;
    }
  }
  .s-p {
    display: flex;
    width: 100%;
    height: 50px;
    line-height: 56px;
    align-items: center;
    flex-direction: flex-start;
    padding: 0 10px;
    border-bottom: 1px solid #e5e5e5;
  }
  .dateTime {
    width: 500px;
  }
  .t-p {
    padding: 12px 10px;
    width: 100%;
    height: calc(100% - 240px);
    overflow-y: auto;
  }
  .p-p {
    display: flex;
    height: 50px;
    justify-content: center;
    // margin-top: 120px;
    align-items: center;
    text-align: center;
  }
}
</style>
